import { d as defineCustomElement } from '../chunks/vidstack-DoOmgEfT.js';
import { MediaAudioLayoutElement } from './vidstack-audio-layout.js';
import { MediaVideoLayoutElement } from './vidstack-video-layout.js';
import '../chunks/vidstack-Bf6opHxk.js';
import '../chunks/vidstack-DB3I3nZp.js';
import '../chunks/vidstack-i0oJKwBM.js';
import '../chunks/vidstack-D1JzjGR7.js';
import '../chunks/vidstack-awVFxJvn.js';
import '../chunks/vidstack-CerDQCFL.js';
import '../chunks/vidstack-B_9E7csz.js';
import '../chunks/vidstack-BYuWkQD6.js';
import '../chunks/vidstack-CMz4Bd8X.js';
import '../chunks/vidstack-CyIpzU-o.js';
import '../chunks/vidstack-B3EgHpRH.js';
import '../chunks/vidstack-2fIzRyOW.js';
import '../chunks/vidstack-XO9MYVWR.js';
import '../chunks/vidstack-ksPACRiU.js';
import '../chunks/vidstack-B2Ww2rqm.js';
import '../chunks/vidstack-CbhL8rpf.js';

defineCustomElement(MediaAudioLayoutElement);
defineCustomElement(MediaVideoLayoutElement);
